import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { AuthProvider } from "@/context/AuthContext";
import { ZipProvider } from "@/context/ZipContext";
import { captureRefFromUrl } from "@/lib/referral";
import Analytics from "@/components/Analytics";
import Home from "@/pages/Home";
import Dashboard from "@/pages/Dashboard";
import Submit from "@/pages/Submit";
import Stores from "@/pages/Stores";
import CouponDetail from "@/pages/CouponDetail";
import AuthCallback from "@/pages/AuthCallback";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import Sponsor from "@/pages/Sponsor";
import DotdKit from "@/pages/DotdKit";
import ResetPassword from "@/pages/ResetPassword";
import StoreDetail from "@/pages/StoreDetail";
import BestDeals from "@/pages/BestDeals";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import TrustBar from "@/components/TrustBar";
import ConciergeChat from "@/components/ConciergeChat";
import ThirdPartyScripts from "@/components/ThirdPartyScripts";
import ExitIntentModal from "@/components/ExitIntentModal";
import { Toaster } from "@/components/ui/sonner";

function AppRouter() {
  const location = useLocation();
  useEffect(() => { captureRefFromUrl(); }, []);
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <div className="flex flex-col min-h-screen">
      <Analytics />
      <Navbar />
      <TrustBar />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/submit" element={<Submit />} />
          <Route path="/stores" element={<Stores />} />
          <Route path="/coupon/:id" element={<CouponDetail />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/sponsor" element={<Sponsor />} />
          <Route path="/sponsor/dotd/kit/:session_id" element={<DotdKit />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/store/:slug" element={<StoreDetail />} />
          <Route path="/best-deals" element={<BestDeals />} />
          <Route path="/best-deals/:topic" element={<BestDeals />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ZipProvider>
            <AppRouter />
            <ThirdPartyScripts />
            <ExitIntentModal />
            <ConciergeChat />
            <Toaster position="top-right" />
          </ZipProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
